import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Returns a map { "Migdolas A20": "Available" | "Reserved" | "Sold" }
export const useInventory = () => {
  const [map, setMap] = useState({});
  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/inventory`)
      .then((res) => {
        if (!active) return;
        const m = {};
        (res.data || []).forEach((i) => (m[i.code] = i.status));
        setMap(m);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  return map;
};

export const statusColor = (status) => {
  switch (status) {
    case "Sold":
      return { text: "sold", cls: "bg-red-900/30 text-red-300 border-red-500/30" };
    case "Reserved":
      return { text: "reserved", cls: "bg-gold/15 text-gold border-gold/40" };
    default:
      return { text: "available", cls: "bg-emerald-900/30 text-emerald-300 border-emerald-500/30" };
  }
};
